/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `subject` - subject
 * * `body` - body
 */
export type ReferencePlacementEnum = typeof ReferencePlacementEnum[keyof typeof ReferencePlacementEnum];


export const ReferencePlacementEnum = {
  subject: 'subject',
  body: 'body',
} as const;
